import { Button } from '@/components/elements/forms/buttons';
import { loginTrackingSession } from '@/helpers/loginTrackingSession';
import { LoginContextType } from '@/hooks/useLogin';
import { _s } from '@/locale';
import { Link } from 'react-router-dom';

type CreateAccountProps = Pick<LoginContextType, 'email' | 'handleEmailSubmit'> & {
  redirectUrl: string;
};
const translationKey = 'CreateAccount';

const CreateAccount = ({ email, redirectUrl, handleEmailSubmit }: CreateAccountProps) => {
  const handleLoginClick = () => {
    handleEmailSubmit({ redirectUrl });
  };

  const handleOnTermsClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    loginTrackingSession.track({ step: 'terms_and_conditions', flow: 'sign-up' });
  };

  return (
    <>
      <p className="text-fg_secondary pb-sm text-m">
        {_s(`${translationKey}.noAccount`)}
        <span className="text-fg_link">{email.value}</span>
      </p>
      <Button onClick={handleLoginClick} size="md">
        {_s(`${translationKey}.cta`)}
      </Button>
      <div className="flex flex-col items-center justify-center">
        <p className="text-fg_secondary text-m">
          {_s(`${translationKey}.terms.text`)}{' '}
          <Link
            onClick={handleOnTermsClick}
            to="/articles/terms-booking-consumer"
            target="_blank"
            className="text-nowrap underline">
            {_s(`${translationKey}.terms.link`)}
          </Link>
        </p>
      </div>
    </>
  );
};

export default CreateAccount;
